import React from 'react'

class ArrowLeftYellow extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17">
        <g fill="none" fillRule="evenodd">
          <g fill="#FCE531">
            <g>
              <g>
                <path
                  d="M6.308 8L10.834 12.525 10.08 13.279 4.8 8 10.08 2.72 10.834 3.474z"
                  transform="translate(-506 -171) translate(328 168) translate(178 3.5) matrix(-1 0 0 1 15.634 0)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

export default ArrowLeftYellow
